import styled from 'styled-components';
import {
  SYS_BREAKPOINT_XS,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_XL,
} from '@oneaudi/unified-web-common';

export const ConversionBarWrapper = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  width: 100%;
  max-width: 1920px;
  height: auto;
  background-color: rgb(255, 255, 255);
  color: rgb(255, 255, 255);
  box-shadow: rgb(229, 229, 229) 0px 0px 1px 1px;
  z-index: 1;
  min-height: 72px;
  margin: 0px auto;
`;

export const ConversionBarContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
`;

export const ConversionBarDefaultBar = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 12px 16px;

  @media (min-width: ${SYS_BREAKPOINT_XS}) {
    padding: 12px 28px;
    justify-content: center;
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    padding: 10px 40px;
    justify-content: space-between;
    gap: none:
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    padding: 20px 60px;
    gap: none;
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    padding: 20px 96px;
  }
  @media (max-width: ${SYS_BREAKPOINT_LG}) {
    gap: 24px;
  }
`;

export const PriceDetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PriceContainer = styled.div<{ isColumn: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-end;
    gap: 8px;
  }
`;

export const RateDetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RateContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
`;

export const InformationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex-direction: column;

  @media (min-width: ${SYS_BREAKPOINT_XS}) {
    flex-direction: column;
    justify-content: center;
    gap: 0px;
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    flex-direction: row;
    justify-content: space-between;
    gap: 24px;
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    gap: 40px;
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    gap: 56px;
  }

  @media (max-width: ${SYS_BREAKPOINT_MD}) {
    width: 100%;
  }
  @media (max-width: ${SYS_BREAKPOINT_XS}) {
    flex-direction: column;
    justify-content: center;
    gap: 0px;
  }
`;

export const FSWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;

  @media (max-width: ${SYS_BREAKPOINT_MD}) {
    width: 100%;
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: auto;
  }
`;

export const ButtonWrapper = styled.div`
  div[role='dialog'] {
    transform: translateY(-100%);
    top: 0px !important;
    width: 291px;

    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      right: 24px;
      left: auto !important;
    }
    @media (max-width: ${SYS_BREAKPOINT_MD} - 1px) {
      right: auto !important;
      left: 50% !important;
      transform: translate(-50%, -100%) !important;
    }
  }
  @media (min-width: ${SYS_BREAKPOINT_XS}) {
    padding-top: 20px;
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    padding-top: 0px;
  }
  @media (max-width: 767px) {
    width: 100%;
    button {
      height: 48px;
      min-height: 48px;
      width: 100%;
    }

    /* Targeting the first child div */
    & > div:first-child div {
      width: 100%;
    }
  }
`;

export const NavigationContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  @media (max-width: ${SYS_BREAKPOINT_MD}) {
    display: none;
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    display: flex;
  }
`;

export const NavBackWrapper = styled.div<{ isColumn: boolean }>`
  a {
    padding-left: 0px;
  }
  @media (min-width: ${SYS_BREAKPOINT_XS}) {
    display: none;
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    display: flex;
    margin-right: 20px;
    align-content: center;
    align-items: center;

    a {
      @media (max-width: ${SYS_BREAKPOINT_MD}) {
        text-indent: -9999px; /* Moves text off-screen */
        overflow: hidden; /* Ensures the text is hidden */
      }
    }
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin-right: ${(props) => (props.isColumn ? '20px' : '50px')};

    a {
      text-indent: ${(props) => (props.isColumn ? ' -9999px' : '0px')}; /* Moves text off-screen */
      overflow: hidden; /* Ensures the text is hidden */
    }
  }
`;
export const BackButtonLabel = styled.span`
  @media (max-width: 1023px) {
    display: none;
  }
`;

export const VehicleDetailWrapper = styled.div`
  @media (min-width: ${SYS_BREAKPOINT_XS}) {
    display: none;
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    display: flex;
    flex-direction: column;
  }
`;

export const TilesRow = styled.div<{ isColumn: boolean }>`
  display: flex;
  align-content: center;
  align-items: flex-start;
  gap: 5px;
  box-sizing: border-box;
  flex-direction: ${(props) => (props.isColumn ? 'row' : 'column')};

  a,
  button {
    margin-right: 0px;
    margin-bottom: 0px;
  }
`;

export const TilesRowItem = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  color: rgb(0, 0, 0);
  height: 48px;

  @media (max-width: ${SYS_BREAKPOINT_MD}) {
    & > button {
      width: 100%;
    }
  }
`;
export const IconWrapper = styled.div`
  max-width: 56px;
`;
